import React from 'react'

export default function Drawer({
  visible, closeDrawer, title, subtitle, action, actionText, disableAction, secondaryActions = [], children
}) {
  if (!visible) return null

  const handleAction = event => {
    event.preventDefault()
    if (!disableAction && action) action()
  }

  return (
    <div className='Drawer'>
      <div className='Drawer__overlay' onClick={ closeDrawer } />

      <aside className='Drawer__content'>
        <div className='Drawer__header'>
          <div className='Drawer__heading'>
            <div className='Drawer__title'>
              { title }
            </div>

            { subtitle &&
              <div className='Drawer__subtitle'>
                { subtitle }
              </div>
            }
          </div>

          <button
            type='button'
            className='Drawer__close'
            onClick={ closeDrawer }
            aria-label={ ReactiveCore.translations.close_action }
          >
            <i className='fa-light fa-xmark' />
          </button>
        </div>

        <div className='Drawer__body'>
          { children }
        </div>

        { (action || secondaryActions.length > 0) &&
          <div className='Drawer__footer flex-box content-end items-center' style={{ gap: 12 }}>
            { secondaryActions.map((secondaryAction, index) => (
              <button
                key={ index }
                type='button'
                className={ `btn ${ secondaryAction.className || 'reverted' } ${ secondaryAction.disabled ? 'disabled' : '' }` }
                onClick={ event => {
                  event.preventDefault()
                  if (!secondaryAction.disabled && secondaryAction.action) secondaryAction.action()
                }}
              >
                { secondaryAction.text }
              </button>
            )) }

            <button
              type='button'
              className='btn'
              onClick={ closeDrawer }
            >
              { ReactiveCore.translations.cancel }
            </button>

            { action &&
              <button
                type='button'
                className={ `btn ${ disableAction ? 'disabled' : '' }` }
                onClick={ handleAction }
              >
                { actionText }
              </button>
            }
          </div>
        }
      </aside>
    </div>
  )
}
